/// <reference path="../../../../typings/tsd.d.ts" /> 
module  warsApp.directives {

   interface IGisWorkflowFunctionScope {
      mapConfiguration: Wars.Domain.Model.Gis.MapConfiguration;
      mapFunctionConfiguration: Wars.Domain.Model.Gis.MapFunctionConfiguration;
      runWorkflow:any;
   }

   export class GisWorkflowFunction {
      constructor() {

      }

      public templateUrl = "./app/views/directives/gis/mapFunction/gisWorkflowFunction.html";
      public restrict: string = "E";
      public controller = ["$scope", "$rootScope",GisWorkflowFunctionController];
      public controllerAs = "controller";
      public scope: any = {
         mapConfiguration: "=",
         mapFunctionConfiguration: "="
      };
   }

   export class GisWorkflowFunctionController {

      constructor(private $scope: IGisWorkflowFunctionScope,
         private $rootScope:angular.IRootScopeService, private gisMapService :services.GisMapService) {
         this.$scope.runWorkflow = () => this.runWorkflow();
      }

      private runWorkflow() {
         this.gisMapService.runWorkflow(this.$scope.mapFunctionConfiguration.gisActionWorkflowConfiguration,
            null,
            services.UtilityService.generateGuidComb()).then(r => {
               this.$rootScope.$broadcast(this.$scope.mapFunctionConfiguration.id, r);
            });
      }
   }
}

warsApp.registerDirective('GisWorkflowFunction',[]);
